/* Responsibility: Scroll to top of page */
import dom from '../../lib/dom.js';

export default function scrollToTop(params) {
    dom.on(params.pagination, 'click', (event) => {
        event.preventDefault();
        params._window.scroll(0, 0);
    });
}
